<template>
      
      <!-- Begin page -->
      <div class="content-page">
            <!-- Start content -->
            <div class="content">
                  <div class="container-fluid">
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="page-title-box">
                                          <h4 class="page-title float-left">考试专区</h4>
                                          <ol class="breadcrumb float-right">
                                                <li class="breadcrumb-item"><a href="#">cpwm</a></li>
                                                <li class="breadcrumb-item"><a href="#">考试专区</a></li>
                                                <li class="breadcrumb-item active">考试报名</li>
                                          </ol>
                                          
                                          <div class="clearfix"></div>
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->
                        
                        
                        <div class="row">
                              <div class="col-12">
                                    <div class="card-box">
                                          <h4 class="header-title m-t-0">说明</h4>
                                          <p class="text-muted m-b-20 font-13">
                                                以下是您本次考试结果
                                          </p>
                                          
                                          <div class="table-responsive">
                                                <table class="table table-bordered table-striped">
                                                      <thead>
                                                      <tr>
                                                            <th>考试名称</th>
                                                            <th class="text-center">
                                                                  考区
                                                            </th>
                                                            <th class="text-center">
                                                                  考试成绩
                                                            </th>
                                                      
                                                      </tr>
                                                      </thead>
                                                      <tbody>
                                                      <tr>
                                                            <th class="text-nowrap" scope="row">{{term}}</th>
                                                            <td>{{address}}</td>
                                                            <td>未通过</td>
                                                      </tr>
                                                      
                                                      </tbody>
                                                </table>
                                          </div>
                                          <div style="width:100%;"> <button type="button" class="btn btn-block btn-sm btn-info waves-effect waves-light" style="background-color:#2CA8FF;width:30%;margin:0 auto;" v-on:click="show_check" v-if="check_button">申请复查</button></div>
                                          <!--提交复查-->
                                          <div style="width:100%;margin-top:5rem;" v-if="check">
                                                <div class="form-group row">
                                                      <label class="col-2 col-form-label">复查原因</label>
                                                      <div class="col-10">
                                                            <textarea class="form-control" rows="5" v-model="ask"></textarea>
                                                      </div>
                                                </div>
                                                <button type="button" class="btn btn-block btn-sm btn-info waves-effect waves-light" style="background-color:#2CA8FF;width:30%;margin:0 auto;" v-on:click="edit_check">提交</button>
                                          </div>
                                          <!--显示复查-->
                                          <div  style="width:100%;margin-top:5rem;" v-if="result">
                                                <h4 class="header-title m-t-0">复查结果</h4>
                                                <div class="table-responsive">
                                                      <table class="table table-bordered table-striped">
                                                            <thead>
                                                            <tr>
                                                                  <th>考试名称</th>
                                                                  <th class="text-center">{{term}}</th>
                                                                  <th class="text-center">考区</th>
                                                                  <th class="text-center">{{address}}</th>
                  
                                                            </tr>
                                                            <tr>
                                                                  <th>复查时间</th>
                                                                  <th class="text-center">{{created_at}}</th>
                                                                  <th class="text-center">回复时间</th>
                                                                  <th class="text-center">{{answer!=null?updated_at:""}}</th>

                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                  <th class="text-nowrap" scope="row">复查原因</th>
                                                                  <td  colspan="3">{{ask}}</td>
                                                            </tr>
                                                            <tr>
                                                                  <th class="text-nowrap" scope="row">回复原因</th>
                                                                  <td  colspan="3">{{answer}}</td>
                                                            </tr>
                  
                                                            </tbody>
                                                      </table>
                                                </div>
                                          </div>
                                    
                                    </div>
                              </div>
                        </div>
                        <!-- end row -->
                  
                  
                  </div> <!-- container -->
            
            </div> <!-- content -->
      
            <!--footer-->
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';
      import Signup from "./signup";
      import signup_result0 from "./signup_result0";
      import signup_result1 from "./signup_result1";
      import signup_result2 from "./signup_result2";
      import signup_result3 from "./signup_result3";
      export default {
            name: 'main',
            components:{Signup, topbar,left,signup_result0,signup_result1,signup_result2,signup_result3},
            data() {
                  return {
                        status:0,
                        address:'',
                        term:'',
                        check:false, //显示提交复查
                        result:false, //复查结果显示
                        check_button:false,
                        
                        ask:'',
                        result_id:'',
                        
                        created_at:'',
                        updated_at:'',
                        answer:'',
                  }
            },
            mounted(){
                  this.show();
            },
            methods: {
                  show: function () {

                        this.$axios({
                              method: 'get',
                              url: '/api/member2/signup_result',
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {

                              this.status = response.data.status;
                              this.address = response.data.address;
                              this.term = response.data.term;
                              if(response.data.ask==null){
                                    this.check_button=true;
                                    this.result_id=response.data.result_id;
                              }else{
                                    this.result=true;
                                    this.ask=response.data.ask;
                                    this.answer=response.data.answer;
                                    this.created_at=response.data.created_at;
                                    this.updated_at=response.data.updated_at;
                              }

                        }.bind(this)).catch(function OnError() {

                        })

                  },
                  show_check:function () {
                        this.check=true;
                  },
                  edit_check:function () {
                        let data = {
                              result_id:this.result_id,
                              ask:this.ask

                        }
                        this.$axios({
                              method: "POST",
                              url: "/api/member2/signup_result_check",
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }

                        }).then(function OnSuccess(response) {
                              if(response.data.code==0){
                                    alert(response.data.msg);
                                    //this.$router.push({path:'/signup_result'});
                                    this.$router.push({path:'/main'});
                                    

                              }else{
                                    alert(response.data.msg);
                              }

                        }.bind(this)).catch(function OnError(response) {
                              console.log(response)
                        })
                  }
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx{width:100%;}
      .zx li{width:100%;float: left}



</style>



// WEBPACK FOOTER //
// src/components/signup_result1.vue